import { ButtonProps } from '@shared/ui/kit/button/model/types';
import { XStylesSettings } from '@shared/types/types';
import { Button } from '@shared/ui/kit/button';
import { ModalProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { Key } from 'react';

const Window = (props: ModalProps) => {
  const {
    size = 'medium',
    active = true,
    title,
    settings,
    settingsHeader,
    settingsContainer,
    settingsFooter,
    children,
    buttons = [],
  } = props;

  return (
    <dialog open={active} {...stylex.props([styles.base, active && styles.active, settings as XStylesSettings])}>
      <div {...stylex.props([styles.title(size), settingsHeader as XStylesSettings])}>{title}</div>
      <div {...stylex.props([styles.container(size), settingsContainer as XStylesSettings])}>{children}</div>
      <div {...stylex.props([styles.footer(size), settingsFooter as XStylesSettings])}>
        {Array.isArray(buttons) &&
          buttons.map((item: ButtonProps, key: Key) => {
            return <Button size={item?.size ?? size} {...item} key={key} />;
          })}
      </div>
    </dialog>
  );
};

export default Window;
